import { offerSelector } from 'selectors/offersSelector'
import { SimpleGuard } from 'interfaces/guards'
import { OfferPageInnerProps } from 'components/features/pfm/OfferPage/OfferPage'
import { getOfferActionCreator } from 'actions/offersActions'
import { createSelector } from 'reselect'

export const offerGuard: SimpleGuard<OfferPageInnerProps> = {
  name: 'Offer',
  checker: createSelector(offerSelector, Boolean),
  loader: (dispatch, ownProps) =>
    dispatch(getOfferActionCreator.request({ id: ownProps.match.params.id })),
}
